(() => {
  const language = document.documentElement.lang.slice(0, 2);
  const copy = ({en:['CONTACT US','Contact VERORARO','Call','Send an email','Chat on WhatsApp','Close','VERORARO assistant','Search furniture, designers...'],fr:['CONTACTEZ-NOUS','Contacter VERORARO','Appeler','Envoyer un email','Discuter sur WhatsApp','Fermer','Assistant VERORARO','Rechercher meubles, designers...']})[language] || ['CONTATTACI','Contatta VERORARO','Chiama','Mail','WhatsApp','Chiudi','Assistente VERORARO','Cerca arredi, designer...'];
  const mobile = matchMedia('(max-width:749px)');
  function prefillProductContact() {
    const field = document.getElementById('ContactForm-body');
    if (!field || field.value.trim()) return;
    const params = new URLSearchParams(location.search);
    const title = params.get('prodotto');
    const reference = params.get('riferimento');
    if (!title || !reference) return;
    let productURL;
    try { productURL = new URL(reference, location.origin); } catch (error) { return; }
    if (productURL.origin !== location.origin || !productURL.pathname.includes('/products/')) return;
    const intro = language === 'en' ? 'Hello, I would like more information about ' : language === 'fr' ? 'Bonjour, je souhaite obtenir plus de renseignements sur ' : 'Buongiorno, vorrei maggiori informazioni su ';
    field.value = intro + title + '.\n' + productURL.href + '\n\n';
  }
  function init() {
    prefillProductContact();
    const input = document.querySelector('.vr-hero-search input[type=search]');
    if (input && !document.body.classList.contains('vr-home-evolution')) {const original=input.getAttribute('placeholder');const update=()=>input.setAttribute('placeholder',mobile.matches?copy[7]:original);update();mobile.addEventListener('change',update);}
    const bar = document.getElementById('vr-contact-bar');
    if (!bar || bar.classList.contains('vr-concierge-ready')) return;
    function alignContactBar() {
      const info = document.querySelector('.product__info-container');
      if (!info || !matchMedia('(min-width:990px)').matches) {bar.style.removeProperty('--vr-contact-start');return;}
      const start = info.getBoundingClientRect().left + 'px';
      if (bar.style.getPropertyValue('--vr-contact-start') !== start) bar.style.setProperty('--vr-contact-start', start);
    }
    alignContactBar();
    window.addEventListener('resize', alignContactBar, {passive:true});
    document.fonts?.ready.then(alignContactBar);
    const phone=bar.querySelector('.vr-contact-phone-panel a[href^="tel:"]');
    const mail=bar.querySelector('.vr-contact-mail'),wa=bar.querySelector('.vr-contact-wa');
    if (!phone || !mail || !wa) return;
    const contactDialog = document.getElementById('vr-product-contact');
    let contactReturnFocus = null;
    function openProductContact(event) {
      event.preventDefault();
      contactReturnFocus = event.currentTarget;
      const mobileSheet = document.getElementById('vr-concierge-sheet');
      if (mobileSheet && mobileSheet.open) mobileSheet.close();
      contactDialog.showModal();
      document.body.classList.add('vr-product-contact-open');
    }
    if (contactDialog) {
      mail.href = '#vr-product-contact';
      mail.setAttribute('aria-haspopup', 'dialog');
      mail.setAttribute('aria-controls', 'vr-product-contact');
      mail.addEventListener('click', openProductContact);
      contactDialog.querySelector('.vr-product-contact-close').addEventListener('click', () => contactDialog.close());
      contactDialog.addEventListener('click', event => {
        if (event.target !== contactDialog) return;
        const bounds = contactDialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) contactDialog.close();
      });
      contactDialog.addEventListener('close', () => {
        document.body.classList.remove('vr-product-contact-open');
        const returnTarget = mobile.matches ? document.querySelector('.vr-concierge-toggle') : contactReturnFocus;
        returnTarget?.focus();
      });
    }
    const toggle=document.createElement('button');toggle.type='button';toggle.className='vr-concierge-toggle';toggle.textContent=copy[0];toggle.setAttribute('aria-haspopup','dialog');toggle.setAttribute('aria-controls','vr-concierge-sheet');toggle.setAttribute('aria-expanded','false');
    const sheet=document.createElement('dialog');sheet.id='vr-concierge-sheet';sheet.className='vr-concierge-sheet';sheet.setAttribute('aria-labelledby','vr-concierge-heading');
    const heading=document.createElement('h2');heading.id='vr-concierge-heading';heading.textContent=copy[1];
    const close=document.createElement('button');close.type='button';close.className='vr-concierge-close';close.textContent='×';close.setAttribute('aria-label',copy[5]);
    sheet.append(heading,close);
    [phone,mail,wa].forEach((source,index)=>{const link=document.createElement('a');link.href=source.href;if(index===1&&contactDialog){link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls','vr-product-contact');link.addEventListener('click',openProductContact);}const icon=(index===0?bar.querySelector('.vr-contact-phone svg'):source.querySelector('svg'))?.cloneNode(true);if(icon){icon.setAttribute('focusable','false');link.append(icon);}const label=document.createElement('span');label.textContent=copy[index+2];link.append(label);if(source.target){link.target=source.target;link.rel='noopener noreferrer';}sheet.append(link);});
    const ai=document.createElement('button');ai.type='button';ai.className='vr-concierge-ai';ai.textContent=copy[6];ai.hidden=true;sheet.append(ai);
    ai.addEventListener('click',()=>{sheet.close();document.getElementById('vr-ai-launcher')?.click();});
    toggle.addEventListener('click',()=>{ai.hidden=!document.getElementById('vr-ai-launcher');bar.querySelector('.vr-contact-phone-panel').hidden=true;sheet.showModal();toggle.setAttribute('aria-expanded','true');});
    close.addEventListener('click',()=>sheet.close());
    sheet.addEventListener('click',event=>{if(event.target===sheet){const r=sheet.getBoundingClientRect();if(event.clientY<r.top)sheet.close();}});
    sheet.addEventListener('close',()=>{toggle.setAttribute('aria-expanded','false');toggle.focus();});
    mobile.addEventListener('change',()=>{if(!mobile.matches&&sheet.open)sheet.close();});
    // Reuse the existing account control and its delegated authentication hooks.
    const headerAccount=document.querySelector('.header .vr-header-lists-account');
    if(headerAccount){
      const footerAccount=headerAccount.cloneNode(true);
      footerAccount.classList.add('vr-footer-account');
      bar.append(footerAccount);
      bar.classList.add('vr-footer-ready');
      bar.setAttribute('aria-label',language==='en'?'VERORARO actions':language==='fr'?'Actions VERORARO':'Azioni VERORARO');
    }
    bar.append(toggle);document.body.append(sheet);bar.classList.add('vr-concierge-ready');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
